export default __webpack_public_path__ + "static/media/helpLawn.4253e11d.png";